export const errorMiddleware = (onError) => () => (next) => (action) => {
  if (action.type.endsWith('_FAILURE')) {
    onError(action.payload);
  }

  return next(action);
};
